import { configureStore } from "@reduxjs/toolkit"
import adminDetails from "../slice/adminSlice"


export const store = configureStore({
  reducer: {
    adminDetails: adminDetails
  }
})